import React from 'react';

const Holiday = ({holiday, message}) => (
  <>
    {
      holiday ?
      <div className="holiday">
        <p className="holiday-name">{holiday}</p>
        {message && <p className="holiday-message">{message}</p>}
      </div>
      :
      null
    }
  </>
);

export default Holiday;